import msgbox, { notify } from './msgbox.js';

let _lastRejectAt = 0;
const REJECT_COOLDOWN_MS = 2500;

function _friendlyMessage(text, status)
{
	if (status === 403)
	{
		try
		{
			const data = JSON.parse(text);
			if (data.method && data.path)
			{
				const hint = data.search_hint ? ` Use a busca em Sistema > Grupos e digite: "${data.search_hint}"` : '';
				return `Acesso negado. Falta permissão para: ${data.method} ${data.path}.${hint} Peça ao administrador para adicionar esse endpoint ao seu grupo.`;
			}
		}
		catch (e) { /* corpo não é JSON, usa mensagem padrão */ }
		return 'Acesso negado. Seu usuário não tem permissão para esta operação. Tente sair e entrar novamente. Se o problema continuar, peça ao administrador para verificar as permissões do seu grupo. (Erro 403)';
	}
	if (status === 401 && text && (text.includes('desabilitado') || text.includes('bloqueado')))
		return text;
	if (status === 401)
		return 'Sessão expirada ou inválida. Faça login novamente. (Erro 401)';
	if (status === 404)
		return 'Recurso não encontrado. O item pode ter sido removido ou você não tem acesso. (Erro 404)';
	if (status >= 500 && text)
		return `Erro no servidor (${status}): ${text}`;
	if (status >= 500)
		return 'Erro temporário no servidor. Tente novamente em alguns instantes. Se persistir, contate o suporte. (Erro ' + status + ')';
	if (text && (text.includes('autorizado') || text.includes('fetch') || text.includes('Failed to fetch')))
		return 'Não foi possível conectar ao servidor. Verifique sua internet e se a API está rodando. Em ambiente de desenvolvimento, execute: python seed_db.py (na pasta src/).';
	return text || 'Ocorreu um erro inesperado. Tente novamente ou contate o suporte.';
}

function notifyRejection(text, title = 'Atenção', status)
{
	const now = Date.now();
	if (now - _lastRejectAt < REJECT_COOLDOWN_MS)
		return;
	_lastRejectAt = now;
	const msg = _friendlyMessage(text, status);
	notify(msg, title);
}

const http = async function(endpoint, ...args)
{

	let mb, response;

	try
	{
		mb = msgbox({ animation: true });
		response = await endpoint(...args);
	}
	catch (e)
	{
		notifyRejection(e.message, 'Atenção', null);
		console.log(e);
	}
	finally
	{
		mb.destroy();
	}

	if (!response)
		return;

	if (!response.ok)
	{
		const body = await response.text();
		notifyRejection(body || `${response.status} ${response.statusText}`, 'Atenção', response.status);
		return;
	}
	const contentType = (response.headers.get('content-type') || '').split(';')[0];
	if (contentType === 'application/json')
		return await response.json();
	if (response.headers.get('content-length') > 0)
		return await response.text();

	return response.ok;

}

export default http;

